import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"mx-3 mt-3 mb-3",attrs:{"tile":"","small":"","color":"success","href":"https://b2b.bicimax.com/products/stock/csv?token=3ab71a1743df862cf331f4ba4d680d89","download":""}},[_vm._v(" Download Stock Artigos ")])
}
var staticRenderFns = []

export { render, staticRenderFns }